import { Injectable } from '@angular/core';
import { ID } from '@datorama/akita';
import { NgEntityService } from '@datorama/akita-ng-entity-service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { CrowdCountObserved } from '../../model/crowd-count-observed';
import { WebsocketService } from '../../service/websocket.service';
import { CrowdCountObservedState, CrowdCountObservedStore } from '../state/crowd-count-observed.store';
import { AkitaHTTPCrowdCountObservedService } from './akita-http-crowdcount-observed.service';
import { UrlConfig } from '../../model/urlconfig';


@UntilDestroy()
@Injectable({ providedIn: 'root' })
export class CrowdCountObservedService extends NgEntityService<CrowdCountObservedState> implements UrlConfig {

  constructor(
    protected store: CrowdCountObservedStore,
    private crowdCountHttpService: AkitaHTTPCrowdCountObservedService,
    private webSocketService: WebsocketService
  ) {
    super(store);

    this.webSocketService.getDataStream('CrowdCountObserved')
      .pipe(untilDestroyed(this))
      .subscribe((data: CrowdCountObserved[]) => this.store.upsertMany(data));
  }
  updateEntitiesUrl(newUrl: string): void {
    this.crowdCountHttpService.setEntitiesUrl(newUrl);
  }

  getAll() {
    this.crowdCountHttpService.getAll().subscribe(crowdFlows => this.store.add(crowdFlows));
  }

  gerById(id: ID) {
    this.crowdCountHttpService.loadById(id).subscribe(crowdFlows => this.store.add(crowdFlows));
  }


}
